import React from 'react';

const ErrorView = ({error}) => (
    "Error!"
);

export default ErrorView;